export default "__VITE_ASSET__CiDNqciF__"